/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

export const trendHotelDailyPreset = {
  rows: {
    header: [11, 12],
  },
  columns: {
    width: [25, ...Array(22).fill(12)],
    end: 'W',
  },
  table: {
    start: 11,
    end: 43,
    dataStart: 13,
  },
  totalRow: false,
  bordered: true,
};
//
export const trendHotelWeeklyPreset = {
  rows: {
    header: [11, 12],
  },
  columns: {
    width: [25, ...Array(22).fill(12)],
    end: 'W',
  },
  table: {
    start: 11,
    end: 20,
    dataStart: 13,
  },
  totalRow: false,
  bordered: true,
};
//
export const trendHotelCumulativePreset = {
  rows: {
    header: [11, 12],
  },
  columns: {
    width: [25, ...Array(13).fill(12)],
    end: 'N',
  },
  table: {
    start: 11,
    end: 43,
    dataStart: 13,
  },
  totalRow: false,
  bordered: true,
};
//
export const trendHotelMovingAveragePreset = {
  rows: {
    header: [10, 11],
  },
  columns: {
    width: [25, ...Array(6).fill(12)],
    end: 'G',
  },
  table: {
    start: 10,
    end: 42,
    dataStart: 12,
  },
  totalRow: false,
  bordered: true,
};
//
export const trendHotelPercentagePreset = {
  rows: {
    header: [9, 10],
  },
  columns: {
    width: [25, ...Array(6).fill(12)],
    end: 'G',
  },
  table: {
    start: 9,
    end: 41,
    dataStart: 11,
  },
  totalRow: false,
  bordered: true,
};
//
export const trendHotelNormalizedPreset = {
  rows: {
    header: [11, 12],
  },
  columns: {
    width: [25, ...Array(22).fill(12)],
    end: 'W',
  },
  table: {
    start: 11,
    end: 43,
    dataStart: 13,
  },
  totalRow: false,
  bordered: true,
};
